/**
 * ProductDetail  Actions - Created by cazarez on 12/03/18.
 */
import {
  DEFAULT_ACTION,
  SHOW_BUYNOW_OPTIONS,
  OPEN_FITINFO,
  SET_SELECTED_GENDER,
  SET_SELECTED_FIT,
  SET_SELECTED_SIZE,
  ADD_ITEM_TO_CART,
  RESET_DATA,
  SET_SELECTED_COLOR,
  DESIGN_MODAL_OPEN,
  SET_QUANTITY,
  SET_UPGRADE_ITEM_DETAIL_ACTION,
  SET_ALREADY_VIEWED,
  SET_INVENTORY,
  OPEN_VINYL_MODAL
} from './constants'
import { AnyAction, ItemDetailType, SelectedType } from '../../types/common'

export const defaultAction = (someValue: string): AnyAction => ({
  type: DEFAULT_ACTION,
  someValue
})

export const openFitInfoAction = (open: boolean) => ({
  type: OPEN_FITINFO,
  open
})

export const setAlreadyViewed = (name: string) => ({
  type: SET_ALREADY_VIEWED,
  name
})

export const setInventoryAction = (inventory: any) => ({
  type: SET_INVENTORY,
  inventory
})

export const showBuyNowOptionsAction = (show: boolean): AnyAction => ({
  type: SHOW_BUYNOW_OPTIONS,
  show
})

export const setUpgradeOption = (
  isFirst: boolean,
  upgrade: ItemDetailType,
  isThird: boolean
): AnyAction => ({
  type: SET_UPGRADE_ITEM_DETAIL_ACTION,
  isFirst,
  upgrade,
  isThird
})

export const setQuantityValue = (value: number): AnyAction => ({
  type: SET_QUANTITY,
  value,
})

export const setSelectedGenderAction = (selected: SelectedType) => ({
  type: SET_SELECTED_GENDER,
  selected
})

export const setSelectedSizeAction = (selected: SelectedType) => ({
  type: SET_SELECTED_SIZE,
  selected
})

export const setSelectedFitAction = (selected: SelectedType) => ({
  type: SET_SELECTED_FIT,
  selected
})

export const addItemToCartAction = (item: any): AnyAction => ({
  type: ADD_ITEM_TO_CART,
  item
})

export const resetReducerAction = (): AnyAction => ({
  type: RESET_DATA
})

export const setSelectedColorAction = (selected: SelectedType): AnyAction => ({
  type: SET_SELECTED_COLOR,
  selected
})

export const setDesignModalOpenAction = (open: boolean): AnyAction => ({
  type: DESIGN_MODAL_OPEN,
  open
})

export const openVinylModalAction = (open: boolean): AnyAction => ({
  type: OPEN_VINYL_MODAL,
  open
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductDetail/actions.ts